import React from 'react';

import { useDispatch } from 'react-redux';

import Drawer from 'components/Drawer';

import { closeAddStoryToPlaylist } from 'store/modules/playlist';

import CreateNewPlaylist from './CreateNewPlaylist';
import LovedStoriesListItem from './LovedStoriesListItem';
import UserPlaylists from './Playlists';

import './style.scss';

const AddStoryToPlaylist = () => {
  const dispatch = useDispatch();

  return (
    <Drawer
      anchor="bottom"
      icon="Arrowdown"
      onClose={() => dispatch(closeAddStoryToPlaylist())}
      open={true}
      header={{ id: 'SM0123.Playlist_Modal.Title' }}
    >
      <div className="AddStoryToPlaylist">
        <UserPlaylists />
        <LovedStoriesListItem />
        <CreateNewPlaylist />
      </div>
    </Drawer>
  );
};

export default AddStoryToPlaylist;
